module.exports = __webpack_public_path__ + "headerPartfilioSlide.9babd428e33a20dd52ed.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/headerPartfilioSlide.jpg
// module id = ../../../../../src/assets/coverPicks/headerPartfilioSlide.jpg
// module chunks = 0